<template>
  <div>
    <AddBarForm :bar="bar" :formTitle="formTitle" :submit="submit" />
  </div>
</template>
<script>
import AddBarForm from "../components/AddBarForm";
import updateBarMutation from "../gql/updateBarMutation";
import { formatPrices } from "../utils";
export default {
  components: {
    AddBarForm
  },
  data: function() {
    return {
      formTitle: "Edit Bar",
      bar: this.$store.state.currentBar
    };
  },
  methods: {
    submit(bar) {
      this.$apollo
        .mutate({
          mutation: updateBarMutation,
          variables: {
            id: bar._id,
            description: bar.description,
            hours: bar.hours,
            name: bar.name,
            address: bar.address,
            imageURLs: bar.imageURLs,
            dailySpecials: bar.dailySpecials,
            happyHours: bar.happyHours,
            prices: formatPrices(bar.prices),
            categories: bar.categories,
            featured: bar.featured,
            published: bar.published
          }
        })
        .then(({ data: { updateBar } }) => {
          if (updateBar) {
            this.$store.commit({ type: "updateBar", payload: bar });
          }
          this.$router.push("all-bars");
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style lang="scss"></style>
